var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        { attrs: { variant: "link", "no-caret": "" } },
        [
          _c("template", { slot: "button-content" }, [
            _c("i", {
              staticClass: "fa fa-ellipsis-v",
              attrs: { "aria-hidden": "true" }
            })
          ]),
          _vm._v(" "),
          _vm.canDelete()
            ? _c(
                "b-dropdown-item-button",
                {
                  on: {
                    click: function($event) {
                      _vm.deleteLote(_vm.data.id)
                    }
                  }
                },
                [_vm._v("Eliminar Lote")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canDelete()
            ? _c(
                "b-dropdown-item-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editLote(_vm.data.id)
                    }
                  }
                },
                [_vm._v("Modificar Lote")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canGestionar()
            ? _c(
                "b-dropdown-item-button",
                { on: { click: _vm.gestionarLote } },
                [_vm._v("Gestionar Lote")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canCerrar()
            ? _c("b-dropdown-item-button", { on: { click: _vm.cerrarLote } }, [
                _vm._v("Cerrar Lote")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPermision("C") || _vm.hasPermision("A")
            ? _c("b-dropdown-item-button", { on: { click: _vm.getLote } }, [
                _vm._v("Ver Lote")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPermision("X")
            ? _c(
                "b-dropdown-item-button",
                { on: { click: _vm.exportarLote } },
                [_vm._v("Exportar Lote")]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/LotesTableActions.vue?vue&type=template&id=d376eace&
// module id = null
// module chunks = 